import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import WorkSection from '../components/WorkSection';
import PartnersSection from '../components/FutureSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  return (
    <div>
      <div id="home">
        <HeroSection />
      </div>
      <div id="how-it-works">
        <WorkSection />
      </div>
      <div id="about">
        <AboutSection />
      </div>
      <div id="partners">
        <PartnersSection />
      </div>
      <div id="contact">
        <ContactSection />
      </div>
    </div>
  );
};

export default HomePage;
